import { render } from "./RootComponent.vue?vue&type=template&id=727dbf9e"
import script from "./RootComponent.vue?vue&type=script&lang=js"
export * from "./RootComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__